import {
  BuildingPeopleRegular,
  HistoryRegular,
  TextBulletListSquareEditRegular,
} from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import MenuItem from "./MenuItem";

function Menu() {
  const { t } = useTranslation();
  return (
    <div className="flex h-16 gap-4">
      <MenuItem
        label={t("assessment")}
        href="/app/assessment"
        Icon={TextBulletListSquareEditRegular}
      />
      {/* <MenuItem
        label={t("company-profile")}
        href="/app/profile"
        Icon={BuildingPeopleRegular}
      />
      <MenuItem
        label={t("assessment-history")}
        href="/app/history"
        Icon={HistoryRegular}
      /> */}
    </div>
  );
}

export default Menu;
